import { ArrowUpRight } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './IntakeLink.module.scss';

const IntakeLink = ({ link, onOpen, title = 'Open intake form', line = false }) => {
  const hasLink = Boolean(link);

  return (
    <a
      href={hasLink ? link : undefined}
      target="_blank"
      rel="noreferrer"
      className={line ? styles.line : `${styles.link} ${hasLink ? '' : styles.disabled}`}
      aria-disabled={!hasLink}
      onClick={(event) => {
        if (!hasLink) {
          event.preventDefault();
          return;
        }
        if (onOpen) {
          event.preventDefault();
          onOpen();
        }
      }}
    >
      {line ? (
        <>
          {title}
          <ArrowUpRight size={14} aria-hidden="true" />
        </>
      ) : (
        <>
          <div className={styles.badge}>
            <span className={styles.badgeText}>I</span>
          </div>
          <div className={styles.meta}>
            <span className={styles.title}>{title}</span>
          </div>
          <span className={styles.arrow} aria-hidden="true">
            ↗
          </span>
        </>
      )}
    </a>
  );
};

IntakeLink.propTypes = {
  link: PropTypes.string,
  onOpen: PropTypes.func,
  title: PropTypes.string,
  line: PropTypes.bool,
};

export default IntakeLink;
